import angular from 'angular';
import ratingComponent from './rating.component';

const rating = angular
	.module('rating', [])
	.component('rating', ratingComponent)
	.name;

export default rating;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/rating/rating.modules.js